import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";

const Counter = ({ end }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 1500;
    const increment = end / (duration / 30);

    const counter = setInterval(() => {
      start += increment;
      if (start >= end) {
        start = end;
        clearInterval(counter);
      }
      setCount(Math.floor(start));
    }, 30);

    return () => clearInterval(counter);
  }, [end]);

  return <span>{count}+</span>;
};

const Experience = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
      easing: "ease-in-out",
    });
  }, []);

  const cards = [
    {
      title: "Years of Experience",
      end: 5,
      desc: "With over 5 years of expertise, we’ve built a reputation for delivering reliable, scalable, and impactful IT solutions.",
    },
    {
      title: "Projects Delivered",
      end: 200,
      desc: "Successfully delivered 200+ projects, empowering startups and enterprises with modern, efficient solutions.",
    },
    {
      title: "Countries Served",
      end: 3,
      desc: "Our technology services have reached clients across 3+ countries, driving digital success globally.",
    },
    {
      title: "Happy Clients",
      end: 150,
      desc: "We value long-term partnerships — with over 150 satisfied clients across diverse industries and Companies  .",
    },
  ];

 return (
  <section className="h-auto min-h-[60vh] flex flex-col justify-center bg-gradient-to-b from-black to-[#111] overflow-hidden py-16">
    <div className="max-w-7xl mx-auto px-6 text-center">

      {/* Header */}
      <motion.h1
        className="text-4xl md:text-5xl font-extrabold mb-4 text-[#D4AF37] drop-shadow-[0_0_10px_rgba(212,175,55,0.4)]"
        data-aos="fade-up"
        style={{ marginTop: "3rem" }}
      >
        Our Experience
      </motion.h1>

      <motion.p
        className="text-gray-400 text-base md:text-lg mb-12 max-w-3xl mx-auto leading-relaxed"
        data-aos="fade-up"
        data-aos-delay="150"
      >
        Over the years, Codex Future Technologies Pvt. Ltd. has continuously delivered
        innovative, user-centric solutions, helping businesses achieve their digital
        transformation goals.
      </motion.p>

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
        {cards.map((card, index) => (
          <div
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 200}
          >
            <motion.div
              className="relative bg-[#0d0d0d]/90 border border-[#d4af37]/30 p-8 rounded-3xl shadow-xl hover:shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:border-[#D4AF37] transition-all duration-300 overflow-hidden"
              initial={{ y: 0 }}
              animate={{ y: [0, -60, 0] }}
              transition={{
                duration: 1.1,
                repeat: Infinity,
                repeatType: 'loop',
                ease: 'easeOut',
                delay: index * 0.2,
              }}
            >
              {/* Gold Glow */}
              <div className="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-500">
                <div className="absolute -top-10 -right-10 w-24 h-24 bg-[#D4AF37]/15 rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 left-0 w-20 h-20 bg-[#D4AF37]/10 rounded-full blur-2xl"></div>
              </div>

              {/* Number */}
              <h3 className="text-3xl font-bold text-[#D4AF37] mb-2 relative z-10 drop-shadow-[0_0_8px_rgba(212,175,55,0.3)]">
                <Counter end={card.end} />
              </h3>

              {/* Title */}
              <h4 className="text-lg font-semibold text-[#D4AF37] mb-3 relative z-10">
                {card.title}
              </h4>

              {/* Description */}
              <p className="text-gray-400 text-sm leading-relaxed relative z-10">
                {card.desc}
              </p>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

};

export default Experience;
